import { Link } from "react-router-dom";
import { FaLock } from "react-icons/fa";
import "./AccessDeniedAdmin.css";

// import { useAuth } from "../../context/AuthContext";
import { isAdmin } from "../../services/adminService";
import { useEffect, useState } from "react";

export default function AccessDenied() {
  const [admin, setAdmin] = useState(false);

  useEffect(() => {
    const check = async () => {
      setAdmin(await isAdmin());
    };

    check();
  }, []);
  return (
    <div className="access-denied">
      <div className="access-card">
        <FaLock className="lock-icon" />

        <h1>Access Restricted</h1>

        <p>This feature is not available in your current subscription plan.</p>

        {/* <p>Please upgrade your plan to unlock this feature.</p> */}

        <div className="buttons">
          <Link to={admin ? "/admin" : "/dashboard"} className="home-btn">
            Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
